// src/components/CreateAccountModal.js
import React, { useState } from "react";
import { X } from "lucide-react";

const CreateAccountModal = ({ onClose, onSwitch }) => {
  const [error, setError] = useState("");

  const handleCreate = (e) => {
    e.preventDefault();
    const name = e.target.name.value.trim();
    const email = e.target.email.value.trim();
    const password = e.target.password.value.trim();

    if (!name || !email || !password) {
      setError("All fields are required.");
      return;
    }

    setError("");
    alert("Account created successfully!");
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]">
      <div className="bg-white w-96 p-6 rounded-lg shadow-lg relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600"
        >
          <X size={20} />
        </button>
        <h2 className="text-2xl font-bold text-center mb-4">
          Create Your Account
        </h2>
        <form className="space-y-4" onSubmit={handleCreate}>
          <input
            name="name"
            type="text"
            placeholder="Full Name"
            className="w-full border p-2 rounded-md"
          />
          <input
            name="email"
            type="email"
            placeholder="Email"
            className="w-full border p-2 rounded-md"
          />
          <input
            name="password"
            type="password"
            placeholder="Password"
            className="w-full border p-2 rounded-md"
          />
          {error && <p className="text-red-500 text-center text-sm">{error}</p>}
          <button
            type="submit"
            className="w-full bg-amber-500 hover:bg-amber-600 text-white py-2 rounded-md"
          >
            Create Account
          </button>
        </form>
        <p className="text-center text-sm mt-3">
          Already have an account?{" "}
          <button
            onClick={() => onSwitch("signin")}
            className="text-amber-600 font-semibold"
          >
            Sign In
          </button>
        </p>
      </div>
    </div>
  );
};

export default CreateAccountModal;
